import { Component } from '@angular/core';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';
@Component({
  selector: 'app-assurance-rc-pro-generale',
  standalone: true,
  imports: [PageLayoutComponent],
  templateUrl: './assurance-rc-pro-generale.component.html',
  styleUrl: './assurance-rc-pro-generale.component.scss'
})
export class AssuranceRcProGeneraleComponent {
  title = 'Assurance RC Pro Générale';
  subtitle = 'La responsabilité civile professionnelle, protection essentielle pour toute activité';
  heroImage = 'assets/images/hero-rc-pro.jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'RC Pro Générale', link: undefined }
  ];

  prevPage = { title: 'Cyber-risque', link: '/assurance-cyber-risque'
  };

  nextPage = { title: 'RC Pro Médicale', link: '/assurance-rc-pro-medicale'
  };
}
